import { service_url } from "rest/const";
import { RestGetSync } from "./getSync";
import { RestPostSync } from "./postSync";
import { URLJoin } from "rest/const";

export function getCatalogSectorsSync() {
  return RestGetSync("/api/catalog/catalogs?catalogTypeId=2");
}

export function getCatalogSubSectorsSync() {
  return RestGetSync("/api/catalog/catalogs?catalogTypeId=3");
}

export function getCatalogGroupsSync() {
  return RestGetSync("/api/catalog/catalogs?catalogTypeId=1");
}

export function getCatalogCategoriesSync() {
  return RestGetSync("/api/catalog/catalogs?catalogTypeId=6");
}

export function reportMolecularCompoundSync(data) {
  return RestPostSync("/api/report/reportMolecularCompound", data);
}

export function getQuartersSync(year) {
  return RestGetSync("/api/saleProductQuarter/quarterComplete?year=" + year);
}

export function reportMolecularCompoundDetailSync(data) {
  return RestPostSync("/api/report/reportMolecularCompoundDetail", data);
}

export function userSync() {
  return RestGetSync("user");
}

export function getSalesSummaryByYearSync(year) {
  return RestGetSync("/api/report/reportCompanies/" + year + "/QUARTER/ALL");
}

export function companiesSync() {
  return RestGetSync("/api/company/companies");
}

export function getSalesSuperIntendenciaCompaniesSync() {
  return RestGetSync("/api/sale/all");
}

export function provincesSync() {
  return RestGetSync("/api/province/provinces");
}

export function cantonsByProvinceSync(provinceId) {
  return RestGetSync("/api/province/cantonsByProvince?provinceId=" + provinceId);
}

export function parroquiasByCantonSync(cantonId) {
  return RestGetSync("/api/canton/parishesByCanton?cantonId=" + cantonId);
}

export function openTemplateSalesReport(companyId) {
  if (companyId === null) {
    companyId = 1;
  }
  const route =
    "/api/saleProductQuarter/downloadExcelTemplate?companyId=" + companyId + "&selection=False";
  const url = URLJoin(service_url, route);
  window.open(url, "_blank");
}

export function openTemplateWithProduct(companyId, quarterId) {
  let route =
    "/api/saleProductQuarter/downloadExcelTemplate?companyId=" +
    companyId +
    "&quarterId=" +
    quarterId +
    "&selection=True";
  const url = URLJoin(service_url, route);
  window.open(url, "_blank");
}

export function catalogsTypeSync() {
  return RestGetSync("/api/catalog/catalogsType");
}

export function downloadTemplateAddProduct() {
  const url = URLJoin(service_url, "/api/product/downloadExcelTemplate");
  window.open(url, "_blank");
}

export function countStoresByProvinceSync() {
  return RestGetSync("/api/store/countStoresByProvince");
  // return [
  //   [
  //       1,
  //       "AZUAY",
  //       "01",
  //       291
  //   ]]
}
